import {padNum, texture, MiniSignal} from "p3";
import definitions from "../../../definitions";
import EnemyFlyingInsect from "./EnemyFlyingInsect";

export default class EnemyButterfly extends EnemyFlyingInsect {
    constructor() {
        super(definitions.ENEMY_ID.BUTTERFLY);

        this.moveSpeed = 900;

        this.signals.grabbed = new MiniSignal();
    }

    init() {
        super.init();

        let frames = [];
        for (let i = 0; i < 5; ++i) {
            frames[i] = texture("butterfly_frames" + padNum(i, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "idle");

        this.addViewWithMovieClip(sequence, "idle");

        this._view.y = -40;

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.2, new PIXI.Point());
    }

    takeDamage(amount) {
        if (this.interactable) {
            this.signals.grabbed.dispatch(this);
        }
        return false;
    }

    onStateUpdate(state) {
        switch (state) {
            case definitions.ENEMY_STATE.WANDER: {
                this.moveToTarget.x = this._initialPosition.x + Math.sin(this._flyTime) * 100;
                this.moveToTarget.y = this._initialPosition.y + Math.sin(this._flyTime2 * 3) * 34 + Math.cos(this._flyTime) * 20;
                this._flyTime += window.dt;
                this._flyTime2 += window.dt;
                break;
            }
        }
    }
}